<section id="mission" class="mission-section py-4">
    <div class="container-fluid px-0">
        <div class="row mb-3">
            <div class="col-12 text-center">
                <h2 class="home-title mb-2">Mission</h2>
                <p>Our Mission is to create LEADERS</p>
            </div>
        </div>
        <div class="mission-cards-wrapper">
            <div class="mission-card" *ngFor="let item of leaders; let i = index"
                [ngClass]="'card-' + item.letter.toLowerCase()"
                [style.background-image]="item.bgImage ? 'url(' + item.bgImage + ')' : 'none'">
                <!-- Background image - uncomment when images are ready -->
                <div class="card-overlay"></div>
                <div class="card-content">
                    <div class="card-text">
                        <!-- <h4 class="card-title">{{ item.letter }}</h4> -->
                        <p class="card-description">{{ item.description }}</p>
                    </div>
                    <div class="card-letter">{{ item.letter }}</div>
                </div>
            </div>
        </div>
    </div>
</section>